import React, { useState, useContext } from 'react';
import { loginUser } from '../../api';
import { UserContext } from '../../context/UserContext';
import Button from '../basic/MyButton';
import TextInput from '../basic/MyTextInput';
import { Link } from 'react-router-dom';
import piggyImage from '../../assets/Logo/Piggy2.png'
import { APP_VERSION } from '../../utils/version';

import './LoginForm.css';

function LoginForm() {
    const [identifier, setIdentifier] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { login } = useContext(UserContext);

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!identifier || !password) {
            setError('Please enter both identifier and password.');
            return;
        }

        try {
            const data = await loginUser(identifier, password);
            console.log('Login response:', data);
            const userDetails = data.user || { identifier };
            console.log('Logging in with:', data.token, userDetails);
            login(data.token, userDetails);
            setError('');
        } catch (error) {
            console.error('Login error:', error);
            setError('Login error: ' + (error.message || 'Please try again later.'));
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={handleLogin} className="login-form">
                <h2 className="login-title">PiggyBunker</h2>
                <img src={piggyImage} alt="Piggy Bank Logo" className="login-logo" />
                <h3 className="login-subtitle">Login / Register</h3>
                <TextInput
                    label="User Name or Email:"
                    type="text"
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                    placeholder="Enter your username or email"
                    error={error && !identifier ? 'Username or email is required' : ''}
                />
                <TextInput
                    label="Password:"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    error={error && !password ? 'Password is required' : ''}
                />
                <Button
                    text="Login"
                    type="submit"
                    color="white"
                    backgroundColor="#007AFF"
                    hoverBackgroundColor="#0056b3"
                    hoverColor="white"
                />
                {error && <p className="error-message">{error}</p>}
                <div className="login-footer">
                    <p>
                        <Link to="/auth/forgot-password" className="forgot-password-link">Forgot Password?</Link>
                    </p>
                    <p>
                        New to PiggyBunker? <strong><Link to="/auth/register" className="register-link">Register</Link></strong>
                    </p>
                    <p className="community-link">
                        <span>Need help? Visit our </span>
                        <a 
                            href="https://community.piggybunker.com/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                        >
                            Community
                        </a>
                    </p>
                    <p className="version-info">
                        Version: {APP_VERSION}
                    </p>
                </div>
            </form>
        </div>
    );
}

export default LoginForm;